/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdmissionPaymentProjection } from '../models/AdmissionPaymentProjection';
import type { InitiateAdmissionPaymentRequest } from '../models/InitiateAdmissionPaymentRequest';
import type { InitiatePaymentResponse } from '../models/InitiatePaymentResponse';
import type { VerifyAdmissionPaymentResponse } from '../models/VerifyAdmissionPaymentResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdmissionPaymentControllerService {
  /**
   * initPayment
   * @returns InitiatePaymentResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static initPaymentUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: InitiateAdmissionPaymentRequest;
  }): CancelablePromise<InitiatePaymentResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/admission-payments',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getApplicationPayments
   * @returns AdmissionPaymentProjection OK
   * @throws ApiError
   */
  public static getApplicationPaymentsUsingGet({
    applicationId,
  }: {
    /**
     * applicationId
     */
    applicationId: string;
  }): CancelablePromise<Array<AdmissionPaymentProjection>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admission-payments/by-application/{applicationId}',
      path: {
        applicationId: applicationId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * verifyPayment
   * @returns VerifyAdmissionPaymentResponse OK
   * @throws ApiError
   */
  public static verifyPaymentUsingGet({
    safsimsTransactionRef,
  }: {
    /**
     * safsims_transaction_ref
     */
    safsimsTransactionRef: string;
  }): CancelablePromise<Array<VerifyAdmissionPaymentResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admission-payments/verify/{safsims_transaction_ref}',
      path: {
        safsims_transaction_ref: safsimsTransactionRef,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
